import React from 'react';
import { Helmet } from 'react-helmet-async';
import HeroBanner from '../components/HeroBanner';
import AboutSection from '../components/AboutSection';
import PrincipalMessage from '../components/PrincipalMessage';
import EventsSection from '../components/EventsSection';
import GallerySection from '../components/GallerySection';
import AlumniSection from '../components/AlumniSection';
import PartnersSlider from '../components/PartnersSlider';
import Footer from '../components/Footer';

const STRUCTURED_DATA = {
  "@context": "https://schema.org",
  "@type": "School",
  "name": "PAK School & College System",
  "description": "PAK School & College System offers quality education with modern facilities, experienced teachers, and comprehensive academic programs in Mardan. Every Student A Star.",
  "url": "https://pakschoolandcollege.com",
  "logo": "https://pakschoolandcollege.com/logo.png",
  "image": "https://pakschoolandcollege.com/assets/hero-banner.jpg",
  "telephone": "0343-0001144",
  "email": "info@pakschoolandcollege.com",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Nehr Chowk, Swabi Road",
    "addressLocality": "Mardan",
    "addressRegion": "Khyber Pakhtunkhwa",
    "addressCountry": "PK"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "34.1958",
    "longitude": "72.0244"
  },
  "foundingDate": "1998",
  "numberOfEmployees": "120",
  "sameAs": [
    "https://www.facebook.com/pakschoolssystem",
    "https://www.instagram.com/pakschoolcollege_mardan"
  ]
};

const Home = () => (
  <div className="page-enter">
    <Helmet>
      <title>PAK School &amp; College System — Every Student A Star | Home</title>
      <meta name="description" content="PAK School & College System offers quality education with modern facilities, experienced teachers, and comprehensive academic programs in Mardan. Every Student A Star." />
      <meta name="keywords" content="PAK School, PAK College, Education Mardan, Pakistan School, Academic Excellence, Student Development, Quality Education, School Admission, Mardan School" />
      <link rel="canonical" href="https://pakschoolandcollege.com/" />
      <meta property="og:title" content="PAK School & College System — Every Student A Star" />
      <meta property="og:description" content="Quality education with modern facilities and experienced teachers in Mardan." />
      <meta property="og:url" content="https://pakschoolandcollege.com/" />
      <meta property="og:type" content="website" />
      <script type="application/ld+json">{JSON.stringify(STRUCTURED_DATA)}</script>
    </Helmet>

    <HeroBanner />
    <AboutSection />
    <PrincipalMessage />
    <EventsSection />
    <GallerySection />
    <AlumniSection />
    <PartnersSlider />
    <Footer />
  </div>
);

export default Home;
